"use strict";

angular.module("customer")
.constant("INVENTORY_HOLDER", {
    "NONE": "",
    "CATALOG_ENTRY": "catalog_entry",
    "PRODUCT": "product"
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/inventory-report/inventory-holder.constants.js
// module id = 889
// module chunks = 0